import React, { ReactNode } from 'react'
import clsx from 'clsx'
import BaseButton from './BaseButton'
import { BaseButtonProps, ElementThemeProps } from 'src/types'

type Props = {
  border?: number
  icon?: ReactNode
} & Omit<ElementThemeProps, 'variant'> &
  BaseButtonProps

function DarkFlatButton({
  border = 2,
  className,
  children,
  type = 'button',
  icon,
  disabled,
  ...others
}: Props) {
  return (
    <div
      className={clsx(
        'inline-block rounded-lg',
        {
          'opacity-70 cursor-not-allowed': disabled,
        },
        className
      )}
      style={{
        border: `${border}px solid #4E8FC6`, // dark yellow border
        backgroundColor: '#121212', // dark background around the button
        padding: '2px',
      }}
    >
      <BaseButton
        className={clsx(
          'w-full font-semibold text-sm transition-all duration-150 rounded-md',
          'flex items-center justify-center gap-2 py-2',
          {
            'bg-[#1a1a1a] text-[#4E8FC6] hover:bg-[#2a2a2a] hover:text-[#f0d000]':
              !disabled,
            'bg-[#2a2a2a] text-[#777777]': disabled,
          }
        )}
        disabled={disabled}
        type={type}
        {...others}
      >
        {icon && icon}
        <div className='inline-flex items-center'>{children}</div>
      </BaseButton>
    </div>
  )
}

export default DarkFlatButton
